import qs from 'query-string';

export function YoutubeEmbed({ oembed }: Props) {
  const aspectRatio = oembed.height / oembed.width;
  const query = oembed.embed_url.slice(oembed.embed_url.indexOf('?'));
  const parsedQuery = qs.parse(query);
  const commonProps = {
    src: `https://www.youtube-nocookie.com/embed/${parsedQuery.v}?feature=oembed`,
    frameBorder: '0',
    allow:
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
    allowFullScreen: true,
  };

  return (
    <div className="mb-xl flex w-full justify-center">
      <div className="contents md:hidden">
        <iframe
          title={oembed.title}
          width="345"
          height={Math.floor(345 * aspectRatio)}
          {...commonProps}
        />
      </div>
      <div className="hidden md:contents">
        <iframe
          title={oembed.title}
          width="560"
          height={Math.floor(560 * aspectRatio)}
          {...commonProps}
        />
      </div>
    </div>
  );
}

type Oembed = {
  width: number;
  height: number;
  embed_url: string;
  title: string;
};

type Props = {
  oembed: Oembed;
};
